<script lang="ts">
  import Account from '~icons/mdi/account';
  import ActionButton from '../components/ActionButton.svelte';
  import { page } from '$app/state';
  import { signModal } from './Signin.svelte';
  import { accountModal } from './AccountModal.svelte';

  type Props = {
    iconOnly?: boolean;
  };
  const props: Props = $props();
</script>

<div class="button-container">
  {#if page.data.user}
    <ActionButton
      iconOnly={props.iconOnly}
      class={page.data.user ? 'pulse-green' : ''}
      onClick={() => accountModal.push()}
    >
      {page.data.user.email?.split('@')[0]}
      <Account />
    </ActionButton>
  {:else}
    <ActionButton
      iconOnly={props.iconOnly}
      onClick={() => signModal.push('up')}
    >
      <Account />
      Become a Premium Member
    </ActionButton>
  {/if}
</div>

<style lang="scss">
  .button-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    & :global(svg) {
      font-size: 24px;
      margin-left: auto;
    }
  }
</style>
